var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternLinkBlue = function SvgExternLinkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00588F",
    fillRule: "nonzero",
    d: "M9.1 3.995V4H3.99A2 2 0 0 0 2 5.995v10.01C2 17.105 2.894 18 3.995 18h10.01A2 2 0 0 0 16 16v-4.023a1 1 0 0 1 2 0V16a4 4 0 0 1-3.995 4H3.995A3.997 3.997 0 0 1 0 16.005V5.995A4 4 0 0 1 3.991 2H9.1v.005a1 1 0 0 1 0 1.99"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#00588F",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.332.995 5.474.256.18 5.398M17.043 2.8l-8.486 8.486"
  })))));
};
export default SvgExternLinkBlue;